import React from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as IconCross } from '../../../assets/icon/ic_close.svg';

const MultiValueRemove = ({
  innerProps: {
    ref, onClick, onMouseDown, onTouchEnd
  },
}) => {
  return (
    <div
      role="presentation"
      ref={ref}
      onClick={onClick}
      className="flex items-center"
      onMouseDown={onMouseDown}
      onTouchEnd={onTouchEnd}
    >
      <IconCross width={18} height={18} className="mr-[6px] text-text-second hover:text-primary-hover" />
    </div>
  );
};

MultiValueRemove.propTypes = {
  innerProps: PropTypes.shape({
    ref: PropTypes.shape({}),
    onMouseDown: PropTypes.func,
    onTouchEnd: PropTypes.func,
    onClick: PropTypes.func,
  }).isRequired
};

export default MultiValueRemove;
